import * as types from './licensePrivilegesPowerSyncActionType';

// License & Privileges Power Sync - start
export const fetchLicensePrivilegesPowerSyncRequest = (data) => ({
    type: types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST,
    payload: data
});
export const fetchLicensePrivilegesPowerSyncSuccess = (data) => ({
    type: types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS,
    payload: data
});
export const fetchLicensePrivilegesPowerSyncFailure = (error) => ({
    type: types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE,
    payload: error
});

export const fetchLicensePrivilegesPowerSyncFilterOptionsRequest = () => ({
    type: types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_REQUEST
});
export const fetchLicensePrivilegesPowerSyncFilterOptionsSuccess = (data) => ({
    type: types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_SUCCESS,
    payload: data
});
export const fetchLicensePrivilegesPowerSyncFilterOptionsFailure = (error) => ({
    type: types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_FAILURE,
    payload: error
});

export const exportLicensePrivilegesPowerSyncRequest = (data) => ({
    type: types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST,
    payload: data
});
export const exportLicensePrivilegesPowerSyncSuccess = (data) => ({
    type: types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_SUCCESS,
    payload: data
});
export const exportLicensePrivilegesPowerSyncFailure = (error) => ({
    type: types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_FAILURE,
    payload: error
});
// License & Privileges Power Sync - end
